import circle from '@turf/circle';
import { geojsonToWKT } from '@terraformer/wkt';
import type { MultiPolygon, Polygon } from 'geojson';

export function radiusAreaGeometry(
  lng: number,
  lat: number,
  radiusMiles: number
): Polygon {
  return circle([lng, lat], radiusMiles, { units: 'miles' }).geometry;
}

/**
 * The backend contract only takes MULTIPOLYGON WKT (see
 * CreateCellRequest.multipolygonWkt), while Mapbox isochrones and turf's
 * circle come back as a plain Polygon. Wrapped as geometry rather than by
 * editing the WKT string, so a polygon with holes stays valid.
 */
export function toMultipolygonWkt(geometry: Polygon | MultiPolygon): string {
  return geojsonToWKT(
    geometry.type === 'MultiPolygon'
      ? geometry
      : { type: 'MultiPolygon', coordinates: [geometry.coordinates] }
  );
}
